import { type CommonAction, response } from "@iflyrpa/share";
import type { ActiomCommonParams } from "../../types";
import { Http } from "../../utils/http";
import { rid } from "../../utils/shipinhao/utils";

export interface CreateShipinhaoCommentParams extends ActiomCommonParams {
    content: string; // 评论内容
    exportId: string; // 文章/视频的导出ID
    rootCommentId?: string; // 根评论ID（回复评论时需要）
    replyCommentId?: string; // 被回复的评论ID（回复评论时需要）
}

export interface CreateCommentResponse {
    errCode: number;
    errMsg: string;
    data?: {
        commentId: string;
        createTime: number;
        success: boolean;
    };
}

export type CreateCommentAction = CommonAction<CreateShipinhaoCommentParams, CreateCommentResponse["data"]>;

export const createShipinhaoComment: CreateCommentAction = async (_task, params) => {
    // 验证必需参数
    if (!params.content || params.content.trim() === "") {
        return response(400, "评论内容不能为空", undefined);
    }

    if (!params.exportId) {
        return response(400, "exportId 不能为空", undefined);
    }

    // 验证 extraParam 是否存在
    if (!params.extraParam) {
        return response(400, "缺少 extraParam 参数", undefined);
    }

    if (!params.extraParam.fingerPrintDeviceId || !params.extraParam.aId || !params.extraParam.uin) {
        return response(400, "fingerPrintDeviceId、aId和uin不能为空", undefined);
    }

    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://channels.weixin.qq.com/micro/interaction/comment",
        origin: "https://channels.weixin.qq.com",
        "content-type": "application/json",
        "finger-print-device-id": params.extraParam.fingerPrintDeviceId,
        "x-wechat-uin": params.extraParam.uin,
    };

    const http = new Http({
        headers,
    });

    const urlParams = new URLSearchParams({
        _aid: params.extraParam.aId,
        _rid: rid(),
        _pageUrl: "https://channels.weixin.qq.com/micro/interaction/comment",
    }).toString();

    const requestData: Record<string, any> = {
        replyCommentId: params.replyCommentId || "",
        content: params.content,
        clientId: `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`,
        rootCommentId: params.rootCommentId || "",
        comment: {},
        exportId: params.exportId,
        timestamp: Date.now().toString(),
        _log_finder_uin: "",
        _log_finder_id: params.extraParam.finderUserName || "",
        rawKeyBuff: null,
        pluginSessionId: null,
        scene: 7,
        reqScene: 7,
    };

    // 如果是回复评论，添加相关参数
    if (params.rootCommentId) {
        requestData.rootCommentId = params.rootCommentId;
    }

    if (params.replyCommentId) {
        requestData.replyCommentId = params.replyCommentId;
    }

    const res = await http.api<CreateCommentResponse>({
        method: "post",
        url: `https://channels.weixin.qq.com/micro/interaction/cgi-bin/mmfinderassistant-bin/comment/create_comment?${urlParams}`,
        data: requestData,
    });

    console.log(res, "----create comment res");

    const isSuccess = res?.errCode === 0;

    return response(isSuccess ? 0 : 414, res?.errMsg || "添加评论失败", res.data);
};
